import {apiService, getAuthValues, setAuthHeader} from "./api";
import {User} from "../models";

async function getInfos(): Promise<User> {
    const {token} = getAuthValues();
    let res;
    setAuthHeader(token!);
    res = await apiService.get<User>("/company?type=getCurrentUser");
    return res.data;
}

async function fetchCountryCode() {
    let res: any;
    try {
        res = await apiService.get(`/public?type=getCountryCodeAPIUrl`);
        if (res.status === 200) {
            const countryRes = await fetch(res.data.url);
            const countryResData = await countryRes.json();
            return countryResData.countryCode;
        } else {
            return null;
        }
    } catch (error) {
        console.error("Error fetching country code", error);
    }
}

export {fetchCountryCode, getInfos};
